import * as mui from '@mui/material'
import React from 'react'

import { translationsContext } from 'context/translations'
import { Calculate, ColumnStatus, Currency, ProductMetrics, Query, Standards } from 'types/graphql/schema'
import { UseQueryBaseReturnType } from 'utils/graphql'
import { valuesType } from 'utils/values'

import { SectionInvestment } from '../SectionInvestment'
import { SectionShortTermReturns } from '../SectionShortTermReturns'
import { SectionLongTermReturnsReproduction } from '../SectionLongTermReturnsReproduction'
import { SectionLongTermReturnsHealth } from '../SectionLongTermReturnsHealth'
import { Dashboard } from '../Dashboard'
import { NotesState } from '../Dashboard/Controls'


export function Main(props: {
  calculate: (values: valuesType) => void
  calculationResult: Calculate
  commonErrors: string[]
  constants: UseQueryBaseReturnType & {data: Query}
  initialCurrency: Currency
  investmentColumnsStatuses: ColumnStatus[]
  setInvestmentColumnsStatuses: (columnsStatuses: ColumnStatus[]) => void
  notesState: NotesState
  pdfRef?: React.RefObject<HTMLDivElement>
  productMetrics: ProductMetrics
  standards: Standards
}) {
  const t = React.useContext(translationsContext)
  
  return (
    <mui.Container
      maxWidth="xl"
      sx={{
        width: t => t.breakpoints.values.xl,
        ...(props.pdfRef
          ? {pt:'20px'}
          : {}
        )
      }}
    >
      <mui.Grid
        container
        spacing={3}
        sx={{
          ...(props.pdfRef
            ? {}
            : {'& > .MuiGrid-root': {pt:0}}
          )
        }}
      >
        <mui.Grid container item xs={9} md={9}>
          <mui.Stack gap={1}>
            {props.commonErrors.map((error, index) => (
              <mui.Alert key={index} severity="error">{error}</mui.Alert>
            ))}
            <SectionInvestment
              calculationResult={props.calculationResult}
              calculate={props.calculate}
              currencies={props.constants.data.currencies}
              columnsStatuses={props.investmentColumnsStatuses}
              setColumnsStatuses={props.setInvestmentColumnsStatuses}
              products={props.constants.data.products}
              productMetrics={props.productMetrics}
              standards={props.standards}
              isPdf={!props.pdfRef}
            />
            <SectionShortTermReturns
              calculate={props.calculate}
              calculationResult={props.calculationResult}
              isPdf={!props.pdfRef}
            />
            <SectionLongTermReturnsReproduction
              calculate={props.calculate}
              calculationResult={props.calculationResult}
              isPdf={!props.pdfRef}
            />
            <SectionLongTermReturnsHealth
              calculate={props.calculate}
              calculationResult={props.calculationResult}
              isPdf={!props.pdfRef}
            />
            <mui.Typography variant="caption" sx={{opacity: .5, textAlign: 'center'}}>
              <i>Copyright 2025 / {t('calc__footer')}</i>
            </mui.Typography>
          </mui.Stack>
        </mui.Grid>
        <mui.Grid container item xs={3} md={3} sx={{position: 'relative'}}>
          <Dashboard
            calculate={props.calculate}
            calculationResult={props.calculationResult}
            constants={props.constants}
            currencies={props.constants.data.currencies}
            feedingRates={props.productMetrics.productFeedingRates}
            initialCurrency={props.initialCurrency}
            notesState={props.notesState}
            pdfRef={props.pdfRef}
            standards={props.standards}
          />
        </mui.Grid>
      </mui.Grid>
    </mui.Container>
  )
}